import api from './authService.js'

export const simulacionesGpsService = {
  // Obtener todas las simulaciones
  async getSimulaciones(filtros = {}) {
    const params = new URLSearchParams()
    
    if (filtros.tipo) params.append('tipo', filtros.tipo)
    if (filtros.estado !== undefined && filtros.estado !== '') params.append('estado', filtros.estado)
    if (filtros.fecha_inicio) params.append('fecha_inicio', filtros.fecha_inicio)
    if (filtros.fecha_fin) params.append('fecha_fin', filtros.fecha_fin)
    if (filtros.busqueda) params.append('busqueda', filtros.busqueda)

    const response = await api.get(`/simulaciones-gps?${params.toString()}`)
    return response.data
  },

  // Obtener solo réplicas
  async getReplicas(filtros = {}) {
    const params = new URLSearchParams()
    
    if (filtros.estado_replica !== undefined && filtros.estado_replica !== '') params.append('estado_replica', filtros.estado_replica)
    if (filtros.fecha_inicio) params.append('fecha_inicio', filtros.fecha_inicio)
    if (filtros.fecha_fin) params.append('fecha_fin', filtros.fecha_fin)
    if (filtros.busqueda) params.append('busqueda', filtros.busqueda)

    const response = await api.get(`/simulaciones-gps/replicas?${params.toString()}`)
    return response.data
  },

  // Obtener simulación por ID
  async getSimulacion(id) {
    const response = await api.get(`/simulaciones-gps/${id}`)
    return response.data
  },

  // Crear nueva simulación
  async createSimulacion(simulacion) {
    const response = await api.post('/simulaciones-gps', simulacion)
    return response.data
  },

  // Actualizar simulación
  async updateSimulacion(id, simulacion) {
    const response = await api.put(`/simulaciones-gps/${id}`, simulacion)
    return response.data
  },

  // Eliminar simulación
  async deleteSimulacion(id) {
    const response = await api.delete(`/simulaciones-gps/${id}`)
    return response.data
  },

  // Duplicar simulación
  async duplicarSimulacion(id) {
    const response = await api.post(`/simulaciones-gps/${id}/duplicar`)
    return response.data
  },

  // Actualizar fechas masivamente
  async actualizarFechas(ids, nuevaFechaHoraFinal) {
    console.log('Enviando datos:', { ids, nuevaFechaHoraFinal })
    console.log('URL:', '/simulaciones-gps/actualizar-fechas')
    const response = await api.post('/simulaciones-gps/actualizar-fechas', {
      ids,
      nuevaFechaHoraFinal
    })
    return response.data
  },

  // Generar ruta automática
  async generarRuta(origen, destino, numPuntos = 20) {
    const response = await api.post('/simulaciones-gps/generar-ruta', {
      origen_lat: origen.lat,
      origen_lng: origen.lng,
      destino_lat: destino.lat,
      destino_lng: destino.lng,
      num_puntos: numPuntos
    })
    return response.data
  },

  // Simular posición GPS
  async simularPosicion(datos) {
    const response = await api.post('/simulaciones-gps/simular-posicion', datos)
    return response.data
  }
} 